import { useFindById, useFindByName } from '@/context/SelectComponent/Base';
import { useGetProjectCodesAllSuspense } from '@/context/services/project_code/ProjectCode.service';
import { useGetProjectsAllSuspense } from '@/context/services/projects/Projects.service';
import { Project, ProjectCode } from 'ap-openapi';

export const useFindProjectCodes = () => {
  const items = useGetProjectCodesAllSuspense();
  const findById = useFindById<ProjectCode, 'id', 'display_name'>(items, {
    key: 'id',
    return: 'display_name',
    defaultVal: '',
  });
  const findByName = useFindByName<ProjectCode, 'display_name', 'id'>(items, {
    key: 'display_name',
    return: 'id',
    defaultVal: '',
  });
  return {
    findProjectCodesById: findById,
    findProjectCodesByName: findByName,
  };
};

export const useFindProjects = () => {
  const items = useGetProjectsAllSuspense();
  const findById = useFindById<Project, 'id', 'display_name'>(items, {
    key: 'id',
    return: 'display_name',
    defaultVal: '',
  });
  const findByName = useFindByName<Project, 'display_name', 'id'>(items, {
    key: 'display_name',
    return: 'id',
    defaultVal: '',
  });
  return {
    findProjectsById: findById,
    findProjectsByName: findByName,
  };
};
